import Bluebird from 'bluebird';
import { findIndexes } from '../../../../../services/arrays';
import { getLocalItem } from '../../../services/browser-storage';
import getCountryCode from '../../../services/country-code';
import getExchangeRates from '../../../services/exchange-rates';
import { currencyOfCountry } from '../../../services/resources';
import { getUrlParam } from '../../../services/url-params';
import { initCurrencyHandlers } from './currency-handlers';
// tslint:disable-next-line:max-line-length
import { CurrencyCode, defaultCurrency, getCurrency, isCurrency, setCurrencyLoaded, setSelectedCurrency } from './currency-storage';
import { addOption, clearOptions, loadCurrencyView, optionVisible } from './currency-view';

export async function loadCurrency(): Bluebird<void> {

    loadCurrencyView();

    const currencyCodes = [
        getUrlParam('currency'),
        getLocalItem('currency') || '',
        currencyOfCountry[await getCountryCode()]
    ];

    // Find valid currency
    const validCurrencies = findIndexes(
        await Bluebird.all(
            currencyCodes.map(code => isCurrency(code))
        ), b => !!b
    ).map(i => currencyCodes[i] as CurrencyCode);

    // Add all options to the view
    clearOptions();

    const rates = await getExchangeRates();
    await Object.keys(rates).sort()
        .map(async (key): Bluebird<void> => {
            const code = key as CurrencyCode;
            if (!optionVisible(code)) {
                await getCurrency(code).then(addOption);
            }
        });

    // Select currency
    await setSelectedCurrency(validCurrencies[0] || defaultCurrency);

    initCurrencyHandlers();
    setCurrencyLoaded();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/bundle/currencies/currency-loader.ts